import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { NgIf } from '@angular/common';
import { filter, Subscription } from 'rxjs';

import { PublicLinkService } from '../../pages/public-link/public-link.service';
import { PublicLink } from '../../pages/public-link/public-link.model';

@Component({
    selector: 'app-link-layout',
    templateUrl: './link-layout.component.html',
    styleUrls: ['./link-layout.component.scss'],
    standalone: true,
    imports: [ RouterOutlet, NgIf ]
})
export class LinkLayoutComponent implements OnInit, OnDestroy {

    public background: string = '';
    public publicLink: PublicLink | null = null;

    private subscription: Subscription = new Subscription();
    public isPublicLinkForm: boolean = false;

    constructor(
        public publicLinkService: PublicLinkService,
        private router: Router,
        private route: ActivatedRoute
    ) {}

    ngOnInit(): void {
        document.body.classList.remove('app-admin', 'p-login', 'p-help', 'environment-development', 'p-link-background');
        document.body.classList.add('p-link');

        this.subscription = this.publicLinkService.publicLink$.subscribe(
            (link) => {
                this.publicLink = link;
                this.setBackground();
            }
        );

        this.routeEvents();
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    private setBackground(): void {
        if (this.publicLink && this.publicLink.metadata && this.publicLink.metadata.background) {
            this.background = `background-image: linear-gradient(rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.4)), url('${this.publicLink.metadata.background}');`;
            document.body.classList.add('p-link-background');
            return;
        }
    }

    private getDeepest(route: ActivatedRoute): ActivatedRoute {
        while (route.firstChild) {
            route = route.firstChild;
        }
        return route;
    }

    private routeEvents(): void {
        this.subscription.add(
            this.router.events.pipe(
                filter((e): e is NavigationEnd => e instanceof NavigationEnd)
            ).subscribe(() => {
                const routeData = this.getDeepest(this.route).snapshot.data;
                this.isPublicLinkForm = !!routeData?.isPublicLinkForm;
                this.publicLinkService.isPublicLinkForm = this.isPublicLinkForm;
            })
        );
    }
}
